/* eslint-disable max-len */
/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	// networkCount         : 0,
	// followPath           : '',
	// pendingPath          : '',
	rFilter          : [],
	// certificate          : 0,
	// markingTab           : 0,
	networkRelations : { initialCount: 0, relations: [], feedRelations: [] },
	// catRealtions         : [],
	// questionBankFilter   : [],
	// // connetions           : { value: 0, connectionCount: 0, mynetwork: [], pending: [], follow: [], block: [] },
	connections      : { approve: [], pending: [], reject: [], suggested: [], following: [], blocked: [] },
	connectionsCount : { approveCount: 0, pendingCount: 0, rejectedCount: 0, suggestedCount: 0, followingCount: 0, blockedCount: 0 },
	// industries           : [],
	suggestions      : [],
	// feedNetworkRelations : { page: 0, relations: [] },
	followPopup      : { follower: [], following: [], mutual: [], companyId: '' }
};

export const newnetworkslice = createSlice({
	name     : 'newnetwork',
	initialState,
	reducers : {

		updateRFilter : (state, action) =>
		{
			state.rFilter = action.payload;
		},

		setNetworkRelations : (state, action) =>
		{
			state.networkRelations = { initialCount: action.payload.initialCount, relations: action.payload.relations, feedRelations: action.payload.feedRelations };
		},

		setConnectionData : (state, action) =>
		{
			state.connections = { ...state.connections, ...action.payload };
		},
		setConnectionCount : (state, action) =>
		{
			state.connectionsCount = { ...state.connectionsCount, ...action.payload };
		},
		getSuggestions : (state, action) =>
		{
			state.suggestions = action.payload;
		},

		setFollowPopup : (state, action) =>
		{
			state.followPopup = { ...state?.followPopup, ...action.payload };
		}
	}
});

export const { setConnectionData, setConnectionCount, setNetworkRelations, updateRFilter, setFollowPopup, getSuggestions } = newnetworkslice.actions;
export default newnetworkslice.reducer;